import React, { useEffect, useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Zoom from "yet-another-react-lightbox/plugins/zoom";

const ImageLightboxViewer = ({ slides, open, index, close, onOpen, showPreview = false }) => {
    const [imgHeight, setImgHeight] = useState("35rem");

    useEffect(() => {
        const updateHeight = () => {
            setImgHeight(window.innerWidth <= 768 ? "25rem" : "35rem");
        };
        updateHeight(); // Set initial height
        window.addEventListener("resize", updateHeight);
        return () => window.removeEventListener("resize", updateHeight);
    }, []);

    return (
        <>
            {showPreview && (
                <div
                    style={{
                        position: "relative",
                        display: "inline-block",
                        cursor: "pointer",
                        overflow: "visible",
                    }}
                    onClick={onOpen}
                >
                    <div
                        style={{ height: imgHeight, borderRadius: 4, display: "block" }}
                    />
                    <i
                        className="ri-zoom-in-line"
                        style={{
                            position: "absolute",
                            top: 0,
                            right: 0,
                            color: "black",
                            padding: 6,
                            fontSize: "1.5rem"
                        }}
                        aria-label="Zoom"
                    />
                </div>
            )}

            <Lightbox
                open={open}
                index={index}
                close={close}
                slides={slides}
                plugins={[Zoom]}
            />
        </>
    );
};

export default ImageLightboxViewer;
